import React from 'react';
import { Box } from '@mui/material';

/**
 * StatusBadge Component
 *
 * Displays a pill-shaped status indicator with color coding
 *
 * @param {Object} props
 * @param {string} props.status - 'available', 'unavailable', 'partial', or null
 */
const StatusBadge = ({ status }) => {
  if (!status) return null;

  const getStatusConfig = () => {
    switch (status) {
      case 'available':
        return {
          label: 'Available',
          bgColor: 'rgba(5, 150, 105, 0.1)',
          textColor: '#059669',
          borderColor: 'rgba(5, 150, 105, 0.3)'
        };
      case 'unavailable':
        return {
          label: 'Not Available',
          bgColor: 'rgba(220, 38, 38, 0.1)',
          textColor: '#dc2626',
          borderColor: 'rgba(220, 38, 38, 0.3)'
        };
      case 'partial':
        return {
          label: 'Conditional',
          bgColor: 'rgba(217, 119, 6, 0.1)',
          textColor: '#d97706',
          borderColor: 'rgba(217, 119, 6, 0.3)'
        };
      default:
        return null;
    }
  };

  const config = getStatusConfig();
  if (!config) return null;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: config.bgColor,
        color: config.textColor,
        border: `1px solid ${config.borderColor}`,
        borderRadius: '12px',
        padding: '4px 10px',
        fontSize: '11px',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        marginTop: '6px',
        fontFamily: 'DM Sans, sans-serif'
      }}
    >
      {config.label}
    </Box>
  );
};

export default StatusBadge;
